<template>
<label :for="id" class="colour-touchpoint" :class="{'colour-touchpoint--checked' : basicColour === this.colour}">
    <input
      type="radio"
      :id="id"
      :value="colour"
      :class="'colour-touchpoint__input'"
      :name="collectionName"
      v-model="basicColour"
      v-validate="validationRules"
      :data-vv-scope="validationScope"
      />
      <span :class="`colour-touchpoint__colour colour-touchpoint__colour--${classColour}`"></span>
      <div :class="`colour-touchpoint__text colour-touchpoint__text--${classColour}`">
        <span>{{text}}</span>
      </div>
</label>
</template>

<script lang="ts">
import VeeValidate, { FieldError, Validator } from 'vee-validate';
import {
  Component,
  Prop,
  Vue,
  Inject,
  Watch
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ExtraData from '@/models/ExtraData';
import SearchQuery from '../../models/SearchQuery';

const SearchQueryModule = namespace('searchQueryModule');

@Component
export default class ColourComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @SearchQueryModule.Action public submitBasicColour;

  @SearchQueryModule.Getter public searchQuery!: SearchQuery;

  @Prop({ default: null })
  public id!: string;

  @Prop({ default: null })
  public text!: string;

  @Prop({ default: '' })
  public colour!: string;

  @Prop({ default: null })
  public collectionName!: string;

  @Prop({ default: null })
  public validationRules!: string;

  @Prop({ default: null })
  public validationScope!: string;

  public get basicColour() {
    return this.searchQuery.basicColour;
  }

  public set basicColour(colour: string | null) {
    this.submitBasicColour(colour);
    if (colour) {
      const extraData = new ExtraData('vehicleColour', colour);
      this.$store.dispatch('enquiryModule/submitExtraData', extraData);
    } else {
      this.$store.dispatch('enquiryModule/submitRemoveExtraData', 'vehicleColour');
    }
  }

  public get classColour() {
    return this.colour.replace(/\s+|[/]/g, '').toLowerCase();
  }

  public created() {
    this.$validator.validateAll(this.validationScope);
  }
}
</script>
